import { createRoute } from "@tanstack/react-router";
import { RoleGuard } from "@/components/auth/RoleGuard";
import { MeetingTypesAdmin } from "@/pages/admin/MeetingTypesAdmin";
import { Route as RootRoute } from "./__root";

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: "/admin/meeting-types",
  component: () => (
    <RoleGuard action="meeting_type_crud">
      <MeetingTypesAdmin />
    </RoleGuard>
  ),
});
